import React from 'react';

import { Table } from 'react-bootstrap';
import styled from 'styled-components';

import { BookingPlatfromActivities } from '../../types/Vendor';

const StyledActivatedCell = styled.td`
  text-align: center;
  background: ${({ activated }) => (activated ? '#66DDAA' : 'inherit')};
  color: ${({ activated }) => (activated ? '#ffffff' : 'inherit')};
`;
type Props = {
  activities: BookingPlatfromActivities[];
  onExperienceOrVariantCreateClick: (
    itemId: string,
    isExperience?: boolean
  ) => void;
};
const VendorBookingPlatformActivitiesList = ({
  activities,
  onExperienceOrVariantCreateClick,
}: Props) => {
  return (
    <div>
      <Table hover>
        <thead>
          <tr>
            <th>Activated</th>
            <th>Supplier Id</th>
            <th>Name</th>
            <th>Item Id</th>
            <th>Integration</th>
          </tr>
        </thead>
        <tbody>
          {activities.map(item => (
            <tr key={item.itemId}>
              <StyledActivatedCell activated={!!item.activityId}>
                {item.activityId ? 'Yes' : 'No'}
              </StyledActivatedCell>
              <td>{item.supplierName}</td>
              <td>{item.name}</td>
              <td>{item.productId}</td>
              <td>{item.integration}</td>
              <td>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => onExperienceOrVariantCreateClick(item.itemId)}
                >
                  Create Experience
                </button>
              </td>
              <td>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() =>
                    onExperienceOrVariantCreateClick(item.itemId, false)
                  }
                >
                  Create Booking Option
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default VendorBookingPlatformActivitiesList;
